export default {
    fuelTypes: [
        {
            name: "Gasoline", value : "Gasoline"
        },
        {
            name: "Special Diesel", value: "SpecialDiesel"
        },
        {
            name: "Gasohol", value: "Gasohol"
        },
        {
            name: "Propane", value: "Propane"
        },
        {
            name: "LNG", value: "LNG"
        },
        {
            name: "CNG", value: "CNG"
        },
        {
            name: "Ethanol", value: "Ethanol"
        },
        {
            name: "Methanol", value: "Methanol"
        },
        {
            name: "E85", value: "E85"
        },
        {
            name: "M85", value: "M85"
        },
        {
            name: "A55", value: "A55"
        },
        {
            name: "Biodiesel", value: "Biodiesel"
        },
        {
            name: "Electricity", value: "Electricity"
        },
        {
            name: "Hydrogen", value: "Hydrogen"
        },
        {
            name: "Hythane", value: "Hythane"
        }
    ]
};
